export enum ThemeEnum{
    ICON_CONTRAST_ADD= 'contrast-dark',
    ICON_CONTRAST='contrast',


    THEME_CURRENT = 'theme-turquoise',
    THEME_NEW = 'aps-theme-dark'
}